/**
 * BaseIcon - Base class for individual icon components
 *
 * This provides a foundation for creating individual icon classes
 * that are pre-configured with specific icon names.
 */

import UIIcon from './UIIcon.js';

class BaseIcon extends UIIcon {
  constructor(iconName, defaultOptions = {}) {
    // Merge default options with provided options
    const options = { size: 16, color: 'currentColor', ...defaultOptions };
    super(iconName, options);
  }

  /**
   * Create a copy of this icon with different options
   * @param {Object} options - Options to override
   * @returns {UIIcon} New icon instance
   */
  copy(options = {}) {
    const mergedOptions = { ...this.options, ...options };
    return new UIIcon(this.iconName, mergedOptions);
  }
}

export default BaseIcon;
